import React from "react";
import { renderRoutes } from "react-router-config";
import { Redirect } from "react-router-dom";
import MainComponent from "./main";
import Layout from "@/app/core/layouts/main";
import Storage from "@/app/core/util/Storage";
import GenericHeader from "@/app/core/layouts/main/components/GenericHeader";
import "@/assets/css/timeline.css";

const ProjectShell = (props) =>
  Storage.isAuthenticated() ? (
    <Layout {...props}>{renderRoutes(props.route.routes, props)}</Layout>
  ) : (
    <div id="page-container">
      <main id="main-container">
        <div
          className="bg-white"
        // style={{
        //   height: "100%",
        //   backgroundImage: "url('assets/media/photos/BG-login.png')",
        //   BackgroundPosition: "bottom"
        // }}
        >
          <GenericHeader hide={true} />
          <div className="row no-gutters bg-black-25">
            <div className="col-md-6 d-flex bg-white">
              <div className="p-1 w-100">
                {renderRoutes(props.route.routes, props)}
              </div>
            </div>

            <div className="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center bg-white"
              style={{
                height: "100%",
                backgroundImage: "url('assets/media/photos/BG-login.png')",
                BackgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="p-3">
                <p className="display-4 font-w700 text-white mb-3">
                  {/* Colocar um texto legal */}
                </p>
                <p className="font-size-lg font-w600 text-white-75 mb-0">
                  Copyright <b>BeeMove</b> &copy;{" "}
                  <span className="js-year-copy">
                    {new Date().getFullYear()}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main >
    </div >
  );

const Redirecter = () => <Redirect to="/error/404" />;

export const TrackingRouter = {
  path: "/tracking",
  component: ProjectShell,
  routes: [
    {
      path: "/tracking",
      exact: true,
      component: MainComponent
    },
    {
      path: "*",
      component: Redirecter
    }
  ]
};
